module.exports = __webpack_public_path__ + "static/media/20150518_005438_322435.f76a5286.mp3";